<template>
    <div>
        <div v-if="!experience" class="flex justify-center md:justify-start">
            <a
                class="group flex justify-center items-center w-12 h-12 rounded-full mt-2 lg:mt-6 bg-primary hover:bg-primary-light transition-colors" 
                @click.prevent="scrollHero()"
                href="#"
                aria-label="Scroll down"
            >
                <svg class="group-hover:translate-y-1 transition-transform" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.19732 9.22748L0.347826 2.37798C-0.115942 1.94989 -0.115942 1.20072 0.347826 0.772631C0.77592 0.308863 1.52508 0.308863 1.95318 0.772631L8.01784 6.80162L14.0468 0.772631C14.4749 0.308863 15.2241 0.308863 15.6522 0.772631C16.1159 1.20072 16.1159 1.94989 15.6522 2.37798L8.80268 9.22748C8.37458 9.69125 7.62542 9.69125 7.19732 9.22748Z" fill="#3B3C4A"/>
                </svg>
            </a>
        </div>

        <a 
            v-if="experience"
            class="button button-icon group justify-start w-full mt-4 py-2 pr-8 "
            @click.prevent="scrollHero()"
            href="#"
        >
            Plan your Visit

            <span class="flex justify-center items-center ml-2 transition-transform group-hover:translate-y-1 rotate-90">
                <img width="18" height="18" :src="arrowUrl" alt="right arrow" loading="lazy">
            </span>
        </a>
    </div>
</template>
<script>
export default {
    props: {
        experience: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        scrollHero() {
            const heroHeight = document.querySelector('.hero').clientHeight

            window.scroll({top: heroHeight, behavior: "smooth"})
        },
    },
    computed: {
        arrowUrl() {
            return window.storage.settings.theme_url + '/assets/images/icons/arrow-right-footer.svg'
        },
    },
}
</script>